import React from 'react'

export default function Logocomponent(props) {
  return (

    <div className='w-[8rem] h-[3.7rem]  flex items-center justify-center bg-white shadow-lg shadow-[#d5e5ef] hover:shadow-gray-300 rounded-xl'>
        <img src={props.img} alt={props.name} className="  w-[6.5rem] h-[3.2rem] object-contain" />
        
      
    </div>
  )
}
